import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background-repeat: repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fce9da;
  background: linear-gradient(
    97deg,
    rgb(252 233 218) 0%,
    rgb(252 233 218) 47%,
    rgb(235 207 184) 100%
  );
`;

export const Container2 = styled.div`
  width: 100%;
  background-color: #a4bbda;
  color: #fff;
`;

export const Image = styled.img`
  height: 500px;
  border-radius: 1rem;

  @media (max-width: 767px) {
    height: 250px;
    justify-content: center;
  }
`;

export const HeroImage = styled.img`
  height: 550px;

  @media (max-width: 767px) {
    height: 250px;
    justify-content: center;
  }
`;

export const HeroLeft = styled.div`
  flex: 0 0 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 767px) {
    padding-top: 2rem;
  }
`;

export const HeroRight = styled.div`
  display: flex;
  flex: 0 0 50%;
  padding: 4rem;
  align-items: center;

  @media (max-width: 1100px) {
    padding-top: 2rem;
    justify-content: center;
  }
`;

export const PartnerLogo = styled.img`
  width: 55px;
  margin-right: 2rem;
`;

export const Text = styled.div`
  font-size: 4rem;
  color: #294c7c;
  font-weight: 700;
`;

export const Hero = styled.section`
  display: flex;
  height: calc(100vh - 10rem);

  @media (max-width: 1100px) {
    height: unset;
    flex-direction: column;
    text-align: center;    
  }
`;

export const Row = styled.div`
  display: flex;
`;

export const Column = styled.div`
  flex: ${(props) => props.size || 1};
`;

export const HeroHeader = styled.header`
  padding-bottom: 3rem;
  color: #ffffff;
  text-shadow: 1px 1px #d3d3d3;

  @media (max-width: 767px) {
    text-align: center;
    font-size: 2.5rem;
  }
`;

export const Delivery = styled.div`
  display: flex;
  align-items: center;
  margin-top: 3rem;
  justify-content: center;  
`;

export const Header = styled.h2`
  text-align: center;
  padding: 3rem;
  color: #fff;
  text-shadow: 1px 1px #cd829e;
  font-family: Merengue;
  font-size: 5rem;
`;

export const Text2 = styled.div`
  header {
    font-size: 2rem;
    color: #294c7c;
    font-weight: 700;
    margin-left: 5rem;
  }

  p {
    padding: 2rem 5rem 2rem 5rem;
  }
`;

export const HeroSeparator = styled.svg`
  display: block;
  background-color: #fce9da;
  background: linear-gradient(
    97deg,
    rgb(252 233 218) 0%,
    rgb(252 233 218) 47%,
    rgb(235 207 184) 100%
  );  
`;

export const HeroPathUp = styled.path`
  opacity: 1;
  fill: #f0a8ae;
`;

export const HeroPathDown = styled.path`  
  fill: #a4bbda;
`;